import Helpers from '@assets/scripts/helpers';

const state = {
	showCreateNew: false,
	modified: false,
	currentMethod: {},
	currentConnection: false,
};

export default () => Helpers.cloneObject(state);
